import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";
import {
  useItemGroupFilteredQuery,
  useItemGroupMutation,
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
  usePostCreateItemGroupMutation
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";

const CreateForm = () => {

  const { data: itemdata1 } = useItemGroupFilteredQuery()
  useEffect(() => {
    if (itemdata1) {
      setParentItemGroup_list(itemdata1.data);

    }

  }, [itemdata1])

  const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [ParentItemGroupApi] = useItemGroupMutation();

  const [ItemTaxTemplateApi] = useItemTaxTemplateMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  const [CreateItemGroup] = usePostCreateItemGroupMutation();

  // tab1
  const [ItemGroupName, setItemGroupName] = useState("");
  const [select_ParentItemGroup, setselect_ParentItemGroup] = useState("");
  const [ParentItemGroup_list, setParentItemGroup_list] = useState([]);
  const [UnicommerceProductCategoryCode, setUnicommerceProductCategoryCode] =
    useState("");
  const [IsGroup, setIsGroup] = useState("");

  const [selected_default_item_data, setselected_default_item_data] =
    useState([]);
  const [selected_tax_item_data, setselected_tax_item_data] =
    useState([]);
  // console.log('tax:',selected_default_item_data)
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    ItemGroupName: false,
    UnicommerceProductCategoryCode: false,
  });

  console.log(UnicommerceProductCategoryCode, "UnicommerceProductCategoryCode")

  // useEffect(() => {
  //   const getParentItemGroup = async () => {
  //     const ParentItemGroupApiData = await ParentItemGroupApi();
  //     setParentItemGroup_list(ParentItemGroupApiData.data.data);
  //   };

  //   getParentItemGroup();

  // }, []);

  const handleSubmit = async () => {

    setFieldErrors({
      ItemGroupName: false,
      // UnicommerceProductCategoryCode: false,
    });

    let hasError = false;
    const newErrors = {
      ItemGroupName: !ItemGroupName,
      // UnicommerceProductCategoryCode: !UnicommerceProductCategoryCode,
    };
    const FirsthasInvalidItem = "";
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);


    if (!ItemGroupName) {
      setptype("Error");
      setError("Please fill Item Group Name.");
      setShowError(true);
      return;
    }
    if (!UnicommerceProductCategoryCode) {
      setptype("Error");
      setError("Please fill Unicommerce Product Category Code.");
      setShowError(true);
      return;
    }


    const payload = {
      docstatus: 0,
      doctype: "Item Group",
      item_group_name: ItemGroupName,
      parent_item_group: select_ParentItemGroup,
      custom_unicommerce_item: UnicommerceProductCategoryCode,
      is_group: IsGroup,
      image: "",
      gst_hsn_code: "",
      item_group_defaults: selected_default_item_data.map(({ item }) => ({
        company: item.company || "",
        default_warehouse: item.default_warehouse || "",
        default_price_list: item.default_price_list || "",
        default_discount_account: "",
        buying_cost_center: "",
        default_supplier: "",
        expense_account: "",
        default_provisional_account: "",
        selling_cost_center: "",
        income_account: "",
        deferred_expense_account: "",
        deferred_revenue_account: "",
      })),
      taxes: selected_tax_item_data.map(({ item }) => ({
        item_tax_template: item.item_tax_template,
        tax_category: item.tax_category,
        valid_from: item.valid_from,
        minimum_net_rate: Number(item.minimum_net_rate),
        maximum_net_rate: Number(item.maximum_net_rate)
      }))
    };

    console.log('create item group payload:', payload)
    try {
      const response = await CreateItemGroup(payload); // RTK mutation or fetch

      function stripHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      }

      if (response.error) {
        let errorMessage = "Creation failed";

        if (response.error.data && response.error.data._server_messages) {
          try {
            const serverMessages = JSON.parse(response.error.data._server_messages);
            if (Array.isArray(serverMessages) && serverMessages.length > 0) {
              const parsedMessage = JSON.parse(serverMessages[0]);
              errorMessage = parsedMessage.message || errorMessage;
            }
          } catch (e) {
            console.warn("Failed to parse _server_messages", e);
          }
        } else {
          errorMessage =
            response.error.data?.message ||
            response.error.data?.exception ||
            errorMessage;
        }

        // ✅ Strip any HTML tags like <strong> from the final error message
        errorMessage = stripHTML(errorMessage);

        setptype("Error");
        setError(errorMessage);
        setShowError(true);
        return;
      }

      setpo_response(response.data);
      setError("Item Group created successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/itemgroup/item-group-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };
  return (
    <FormLayout
      title="New Item Group"
      breadcrumbs={[
        { label: "Item Group" },
        { label: "Item Group List", url: "/master/itemgroup/item-group-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => { }}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/itemgroup/create-item-group"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
              <span style={{ position: "relative", top: "-1px" }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>
          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    ItemGroupName={{
                      ItemGroupName: ItemGroupName,
                      setItemGroupName: setItemGroupName,
                      Error: fieldErrors.ItemGroupName,
                    }}
                    ParentItemGroup={{
                      ParentItemGroup_list: ParentItemGroup_list,
                      setselect_ParentItemGroup: setselect_ParentItemGroup,
                      select_ParentItemGroup: select_ParentItemGroup,
                      Error: fieldErrors.ParentItemGroup
                    }}
                    UnicommerceProductCategoryCode={{
                      UnicommerceProductCategoryCode:
                        UnicommerceProductCategoryCode,
                      setUnicommerceProductCategoryCode:
                        setUnicommerceProductCategoryCode,
                      Error: fieldErrors.UnicommerceProductCategoryCode,
                    }}
                    IsGroup={{
                      IsGroup: IsGroup,
                      setIsGroup: setIsGroup,
                      Error: fieldErrors.IsGroup,
                    }}
                  />
                  <Tab2
                    setselected_default_item_data={setselected_default_item_data}
                  />
                  <Tab3
                    setselected_tax_item_data={setselected_tax_item_data}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default CreateForm;
